import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import SiteContainer from '../components/common/SiteContainer';

import '../../public/static/fonts.css'
import '../../public/static/style.css'
import './index.css'

const DefaultLayout = ({ children }) => (
  <SiteContainer>
    <Helmet
      title="The Hitchhiker's Guide to Javascript"
      meta={[
        { name: 'description', content: 'A roaring adventure through the universe of Javascript' },
      ]}
    />
    {children()}
  </SiteContainer>
)

DefaultLayout.propTypes = {
  children: PropTypes.func,
}

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js